import React from 'react';
import { useIntl } from 'react-intl';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Card } from '../../components/Card';
import { Button } from '../../components/Button';
import { IDevicesState } from '../devices/devices.slice';
import { IRequestParams } from '../../components/types';
import styles from './manageCustomers.styles';
import { DeviceGrid } from '../../components/device-grid/device-grid';

interface IDevicesCardProps extends WithStyles<typeof styles> {
  selectDevice: IDevicesState;
  onAddDevice: () => void;
  onRemoveDevice: (deviceName: string, callback: () => void) => void;
  handleDeleteDevice: (data: any) => void;
  handleGetDevices: ({ limit, offset, sortOrder }: IRequestParams) => void;
}

const DevicesCard: React.FC<IDevicesCardProps> = ({
  classes,
  selectDevice,
  onAddDevice,
  handleDeleteDevice,
}) => {
  const intl = useIntl();

  return (
    <Card>
      <div className={classes.cardContentWrapper}>
        <div style={{ float: 'right' }}>
          <Button
            id="add-device"
            label={intl.formatMessage({
              id: 'add_device',
            })}
            variant="contained"
            onClick={onAddDevice}
          />
        </div>
        <DeviceGrid
          onDeleteDeviceClick={handleDeleteDevice}
          /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
          // @ts-ignore
          devices={selectDevice.list.data}
          isLoading={selectDevice.loading}
          columnNames={[
            'id',
            'name',
            'rebootStatus',
            'action'
          ]}
          id="device-data-table"
        />
      </div>
    </Card>
  );
};

export default withStyles(styles)(DevicesCard);
